export function createSignal<T>(initialVal: T) {
  let signalVal: T = initialVal;

  function setSignal(val: T) {
    signalVal = val;
  }

  function getSignal() {
    return signalVal;
  }

  return { setSignal, getSignal };
}
